import React from "react";
import { WheelListingContainer } from "./styles";
import { WheelListingCard } from "./WheelListingCard";
import { Skeleton } from "@mui/material";

export const WheelListing = ({ wheels, isFetchingNextPage, openWheel, selectedWheelCategory }) => {
    return (
        <>
        <WheelListingContainer>
            {wheels?.map((wheel) => (
                <WheelListingCard
                    key={wheel.id}
                    wheel={wheel}
                    openWheelDetails={() => openWheel(wheel.id)}
                />
            ))}
        </WheelListingContainer>
        {isFetchingNextPage && (
            <Skeleton
                variant="rectangular"
                width="30vw"
                height="36px"
                sx={{ borderRadius: "8px" }}
            />
        )}
        </>
    )
}